import { router } from './router';
// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
import { getToken, toLogin } from '@/utils/auth'

// NProgress.configure({ showSpinner: false })

const whiteList = ['/dispatcher','/pdf']

router.beforeEach((to, from, next) => {
  // NProgress.start()
  if (!getToken()) {
    console.log(to.path)
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      toLogin(to.path)
      // NProgress.done()
    }
  } else {
    next()
  }
})

// router.afterEach(() => {
//   NProgress.done()
// })
